import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import DataTableHeaderRow from "./DataTableHeaderRow";
import { columnPropType } from "./propTypes";
export default class DataTableHeader extends PureComponent {
  static propTypes = {
    columns: PropTypes.arrayOf(columnPropType).isRequired,
    rowProps: PropTypes.object,
    selected: PropTypes.bool,
    onSelectionChange: PropTypes.func,
  };

  render() {
    const { columns, rowProps, selected, onSelectionChange, ...otherProps } = this.props;
    return (
      <thead {...otherProps}>
        <DataTableHeaderRow {...rowProps} columns={columns} selected={selected} onSelectionChange={onSelectionChange} />
      </thead>
    );
  }
}
